import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';
const Shared: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={`inline animate-spin ${className}`}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="loadingGradient"
          x1="2"
          y1="20"
          x2="38"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor={color || '#C4FAC3'} stopOpacity="0" />
          <stop offset="50%" stopColor={color || '#C4FAC3'} stopOpacity="1" />
          <stop offset="100%" stopColor={color || '#C4FAC3'} stopOpacity="0" />
        </linearGradient>
      </defs>
      <circle
        cx="20"
        cy="20"
        r="18"
        stroke="#F7F7F7"
        strokeWidth="4"
        fill="none"
        strokeOpacity="0.2"
      />
      <circle
        cx="20"
        cy="20"
        r="18"
        stroke="url(#loadingGradient)"
        strokeWidth="4"
        fill="none"
        strokeDasharray="56.55 56.55"
        strokeDashoffset="0"
        strokeLinecap="round"
        transform="rotate(0 20 20)"
      />
    </svg>
  );
};
export default Shared;
